import { serverFetch } from "@core/server";

export function fetchSprNumberList(idBranch) {
  return serverFetch("sprs/number", {
    queryParams: idBranch ? { idBranch } : undefined
  });
}

export function fetchSprNumber(idNumber) {
  return serverFetch(`sprs/number/${idNumber}`);
}

export function fetchSprNumberCategories() {
  return serverFetch("sprs/number/categories");
}

export function fetchSprNumberBranches() {
  return serverFetch("sprs/number/branches");
}

export function createSprNumber(bodyData) {
  return serverFetch("sprs/number", {
    method: "POST",
    bodyData
  });
}

export function saveSprNumber(bodyData) {
  return serverFetch("sprs/number", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprNumber(idNumber) {
  return serverFetch(`sprs/number/${idNumber}`, {
    method: "DELETE"
  });
}

/** Заполнение REG_NUMBER_DAYS (Delphi TFrmActFillGraph). */
export function fillSprNumberDays(bodyData) {
  return serverFetch("sprs/number/days/fill", {
    method: "POST",
    bodyData
  });
}
